export enum VALUE_COLORS {
  GOOD = 90,
  NORMAL = 70,
}
